const organization_sessions = (state) => state.organization_sessions;
const organization_sessions_view = (state) => state.organization_sessions_view;
const organization_revisions_view = (state) =>
  state.organization_revisions_view;
const organization_revisions = (state) => state.organization_revisions;
const organization_create_revisions_view = (state) =>
  state.organization_create_revisions_view;
const organization_create_revisions = (state) =>
  state.organization_create_revisions;
const organization_update_revisions_view = (state) =>
  state.organization_update_revisions_view;
const organization_update_revisions = (state) =>
  state.organization_update_revisions;
const organization_destroy_revisions_view = (state) =>
  state.organization_destroy_revisions_view;
const organization_destroy_revisions = (state) =>
  state.organization_destroy_revisions;
const user_revisions = (state) => state.user_revisions;
const user_revisions_view = (state) => state.user_revisions_view;
const user_actions = (state) => state.user_actions;
const user_actions_view = (state) => state.user_actions_view;
const user_revisions_error = (state) => state.user_revisions_error;
const change_audit = (state) => state.change_audit;
const sessionUser = (state) => (id) => {
  return state.organization_sessions.included.find(
    (user) => user.id === id && user.type === "users"
  );
};
const user_list = (state) => state.user_list;
const user_list_view = (state) => state.user_list_view;
const broadcasts = (state) => state.broadcasts;
const join_requests = (state) => state.join_requests;
const simple_join_requests = (state) => state.simple_join_requests;
const packets = (state) => state.packets;
const network_statistics = (state) => state.network_statistics;
const gateway_statistics = (state) => state.gateway_statistics;
const join_requests_quantities = (state) => state.join_requests_quantities;
const packets_quantities = (state) => state.packets_quantities;
const stats = (state) => state.stats;
const crc_errors = (state) => state.crc_errors;
const missed_packets = (state) => state.missed_packets;
const search_results = (state) => state.search_results;
const system_summary = (state) => state.system_summary;
const licenses = (state) => state.licenses_object;
const organization_schedule_provisioning = (state) =>
  state.organization_schedule_provisioning;

export default {
  broadcasts,
  organization_sessions,
  organization_sessions_view,
  organization_revisions,
  organization_revisions_view,
  organization_create_revisions,
  organization_create_revisions_view,
  organization_update_revisions,
  organization_update_revisions_view,
  organization_destroy_revisions,
  organization_destroy_revisions_view,
  user_revisions,
  user_revisions_view,
  user_actions,
  user_actions_view,
  user_revisions_error,
  change_audit,
  sessionUser,
  user_list,
  user_list_view,
  join_requests,
  simple_join_requests,
  packets,
  network_statistics,
  gateway_statistics,
  join_requests_quantities,
  packets_quantities,
  stats,
  crc_errors,
  missed_packets,
  search_results,
  system_summary,
  licenses,
  organization_schedule_provisioning,
};



// WEBPACK FOOTER //
// ./src/modules/organizationStates/store/getters.js